import menuData from "../../assets/list/menu.json";
import logo from "../../assets/images/capybar.png";

export default function Drinks() {
  const drinks = menuData.drinks;

  return (
    <div className="home">
      <header className="navbar">
        <div className="navbar-content">
          <nav className="nav-links">
            <a href="/">Inicio</a>
            <a href="/menu">Menú</a>
            <a
              href="https://www.instagram.com/capy_bar025"
              target="_blank"
              rel="noopener noreferrer"
            >
              Contactanos
            </a>
          </nav>
          <div className="nav-logo">
            <img src={logo} alt="Capybar Bar" />
          </div>
        </div>
      </header>

      <main className="menu-list">
        {Object.entries(drinks).map(([key, item]) => (
          <div className="menu-item" key={key}>
            <img src={item.image} alt={key} className="menu-item-img" />
            <h3>{key.replace(/[_]/g, " ").replace(/[-]/g, "\'")}</h3>
            <p>{item.price}</p>
          </div>
        ))}
      </main>

      <footer className="footer">
        <div className="footer-info">
          <p>© {new Date().getFullYear()} Capy-Bar. Todos los derechos reservados.</p>
          <p>Todas las imagenes son demostrativas.<br></br>Hecho con ❤️ por el equipo Capy-bar</p>
        </div>
      </footer>

      <style>{`
        .menu-list {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 30px;
          padding: 50px;
        }

        .menu-item {
          background: rgba(245, 197, 24, 0.15);
          backdrop-filter: blur(8px);
          border-radius: 15px;
          width: 220px;
          text-align: center;
          padding: 15px;
          color: white;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }

        .menu-item:hover {
          transform: translateY(-8px);
          box-shadow: 0 8px 25px rgba(245, 197, 24, 0.5);
        }

        .menu-item-img {
          width: 100%;
          height: 150px;
          object-fit: cover;
          border-radius: 10px;
          margin-bottom: 10px;
        }

        .menu-item h3 {
          color: #f5c518;
          font-size: 1.1rem;
          margin-bottom: 5px;
          text-transform: capitalize;
        }

        .menu-item p {
          color: #fff;
          font-weight: 500;
        }

        @media (max-width: 600px) {
          .menu-item {
            width: 90%;
          }
        }
      `}</style>
    </div>
  );
}
